import React from 'react';
import { Link } from "../../../link/Link.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomLink({
  element
}) {
  return /*#__PURE__*/_jsx(Link, {
    inline: true,
    target: "_blank",
    ...element.componentProps
  });
}